<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="heading-line"><span class="bold">S<span class="small">OUTH</span> W<span class="small">ALES</span> V<span class="small">ALLEYS</span></span></p>
<p class="half">Railways and Industry on the BRECON &amp; MERTHYR<a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?58084f5a